
;(function($, _window, _document) {

  const $blocks = $('.block-tiles-teaser');
  if (!$blocks.length) return;


  initialiseTiles();

  $(window).on('resize', () => {
    initialiseTiles();
  })


  // Click-to-toggle on any .expandable element within a tile
  $blocks.find('.expandable').on('click', function () {

    if (window.innerWidth < 992) { return }
    const $wrapper = $(this).closest('.tms-tile-wrapper');
    if ($wrapper.hasClass('is-expanded')) {
      collapseTile(this);
    } else {
      expandTile(this, true);
    }
  });

  $blocks.find('.tms-tile').on('mouseenter', function() {
    expandTile(this, false)
  });
  $blocks.find('.tms-tile').on('mouseleave', function() {
    collapseTile(this)
  });


  function initialiseTiles() {

    // Stacked card
    if (window.innerWidth < 992) { 
      $('.tms-tile-wrapper .tile-reveal').attr('aria-hidden', false);
      $('.tms-tile-wrapper .tile-reveal').find('a').removeAttr('tabindex');

    // Expander card
    } else {
      $('.tms-tile-wrapper .tile-reveal').attr('aria-hidden', true);
      $('.tms-tile-wrapper.is-expanded .tile-reveal').attr('aria-hidden', false);
    }
  }

  function expandTile(el: any, scrollIntoView = false) {
    const $wrapper = $(el).closest('.tms-tile-wrapper');
    const $reveal = $wrapper.find('.tile-reveal');

    $wrapper.addClass('is-expanded');
    $wrapper.find('.expander').attr('aria-pressed', 'true');
    $reveal.attr('aria-hidden', 'false');
    $reveal.find('a').removeAttr('tabindex');

    if (scrollIntoView) {
      const wrapperEl = $wrapper[0];
      if (wrapperEl) {
        const rect = wrapperEl.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top < 0 || rect.bottom > viewportHeight) {
          wrapperEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  }

  function collapseTile(el: any) {
    const $wrapper = $(el).closest('.tms-tile-wrapper');
    const $reveal = $wrapper.find('.tile-reveal');

    $wrapper.removeClass('is-expanded');
    $wrapper.find('.expander').attr('aria-pressed', 'false');
    $reveal.attr('aria-hidden', 'true');
    $reveal.find('a').attr('tabindex', '-1');
  }

// @ts-ignore
})(jQuery, window, document);
